// extracted by css-extract-rspack-plugin
export default {"dotsContainer":"U539CY20","passCodeInput":"aO8mpf1F","passCodeOverlay":"WnuEwQkW","dot":"AoIQMBFG","selected":"MTjCWawF","hintWrapper":"A0NqpzyF","biometryButton":"uVMLbjLd"};